import { render, staticRenderFns } from "./BookingEditStatus.vue?vue&type=template&id=e21124da&scoped=true&"
import script from "./BookingEditStatus.vue?vue&type=script&lang=js&"
export * from "./BookingEditStatus.vue?vue&type=script&lang=js&"
import style0 from "./BookingEditStatus.vue?vue&type=style&index=0&id=e21124da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21124da",
  null
  
)

export default component.exports